<template>
    <div>
        <b-row class="mb-2">
            <b-col class="text-right">
                <b-button @click="add" class="btn btn-light">{{Core.Definition.getDefinition('Nouvelle équipe')}}</b-button>
            </b-col>
        </b-row>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: 'ParticipantTeamContainer',
        components: {
        },
        mounted() {
        },
        data () {
            return {
                Core: window.Core
            }
        },
        methods: {
            add() {
                if (this.$route.fullPath === window.Core.Definition.getDefinition('/participant/equipes/nouvelle-equipe')) {
                    location.reload()
                } else {
                    this.$router.push(window.Core.Definition.getDefinition('/participant/equipes/nouvelle-equipe'))
                }
            }
        }
    }
</script>
